import React, { useEffect, useState } from "react";
import classes from "../customer.module.css";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchAuditTrial } from "../../../../Redux/actions/customerActions";
import {
  FilterFunnelIcon,
  OppositeSortArrawBtnIcons,
  SortArrawBtnIcons,
  DatePickerCalendarIcon,
} from "../../../../Components/Icons/Icons";
import dayjs from "dayjs";
import { handleSortClick } from "../../../../Utilities/commonfunctions";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box, Button } from "@mui/material";

const AuditTrial = (props) => {
  const dispatch = useDispatch();
  const { sortBy } = useSelector((state) => state.filter);
  const [showCalendar, setShowCalendar] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    dispatch(
      fetchAuditTrial(
        props.id,
        sortBy,
        fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : null,
        toDate ? dayjs(toDate).format("YYYY-MM-DD") : null
      )
    );
  }, [sortBy, fromDate, toDate, dispatch, props]);

  const auditTrialData = useSelector((state) => state.customerData);

  const { loading, error, auditTrials } = auditTrialData || {};

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  return (
    <div>
      <div>
        <Table className={classes.MainTable}>
          <TableHead>
            <TableRow className={classes.tableHeadRow}>
              <TableCell className={classes.tableHeadCell}>
                <div className={classes.tableHEadercelldiv}>
                  <span> Date & Time </span>{" "}
                  <span style={{ marginLeft: "5px" }} onClick={toggleCalendar}>
                    <FilterFunnelIcon />
                  </span>
                  <Dialog
                    open={showCalendar}
                    onClose={toggleCalendar}
                    className={classes.CalendarRangeContainer}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <DesktopDatePicker
                          label="From Date"
                          value={fromDate}
                          onChange={(newValue) => setFromDate(newValue)}
                          format="DD/MM/YYYY"
                          slots={{ openPickerIcon: DatePickerCalendarIcon }}
                          slotProps={{ textField: { size: 'small' } }}
                        />
                        <DesktopDatePicker
                          label="To Date"
                          value={toDate}
                          onChange={(newValue) => setToDate(newValue)}
                          format="DD/MM/YYYY"
                          slots={{ openPickerIcon: DatePickerCalendarIcon }}
                          slotProps={{ textField: { size: 'small' } }}
                        />
                        <Button variant="contained" size="small" onClick={toggleCalendar}>
                          Apply
                        </Button>
                      </Box>
                    </LocalizationProvider>
                  </Dialog>
                  <span
                    onClick={() =>
                      handleSortClick(dispatch, sortBy, "createdAt")
                    }
                  >
                    {sortBy?.includes("desc") &&
                    sortBy?.includes("createdAt") ? (
                      <OppositeSortArrawBtnIcons />
                    ) : (
                      <SortArrawBtnIcons />
                    )}
                  </span>
                </div>
              </TableCell>
              <TableCell className={classes.tableHeadCell}>
                <span> Action </span>
                <span
                  onClick={() => handleSortClick(dispatch, sortBy, "action")}
                >
                  {sortBy?.includes("desc") && sortBy?.includes("action") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </TableCell>
              <TableCell className={classes.tableHeadCell}>
                <span> Channel </span>
                <span
                  onClick={() => handleSortClick(dispatch, sortBy, "channel")}
                >
                  {sortBy?.includes("desc") && sortBy?.includes("channel") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </TableCell>
              <TableCell className={classes.tableHeadCell}>
                IP Address
                <span
                  onClick={() =>
                    handleSortClick(dispatch, sortBy, "ip_address")
                  }
                >
                  {sortBy?.includes("desc") &&
                  sortBy?.includes("ip_address") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <td colSpan="9" className="text-center">
                  Loading...
                </td>
              </TableRow>
            ) : error ? (
              <TableRow>
                <td colSpan="9" className="text-center">
                  {error}
                </td>
              </TableRow>
            ) : auditTrials && auditTrials.length > 0 ? (
              auditTrials.map((item, index) => (
                <TableRow className={`${classes.table_bg1}`}>
                  <TableCell>
                    <p className="mb-0">
                      {dayjs(item.createdAt).format("DD MMM YYYY")}
                    </p>
                    <span>{dayjs(item.createdAt).format("HH:mm A")}</span>
                  </TableCell>
                  <TableCell>{item.action}</TableCell>
                  <TableCell>{item.channel}</TableCell>
                  <TableCell>{item.ip_address}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <td colSpan="9" className="text-center">
                  No Data Found
                </td>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default AuditTrial;
